// extracted by mini-css-extract-plugin
export default {"wrapper":"zPm0_Q9kypW4TTPCy5mP"};